import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import newDetail from "../constants/news-preview/newsDetaile";
import "./index.scss";
import banner from "../assets/aboutus/banner-bg.png";
import { DownOutlined } from "@ant-design/icons"

function LatestNews (props) {

    const [year, setYear] = useState("all");

    const toNewsDetail = (index) => {
        props.history.push({ pathname: "/news-detail", state: { newsId: index } })
    }

    const years = new Set(newDetail.map(news => {
        return news.header[0].split("年")[0] + "年"
    }))

    return <div className="latest-news">
        <div className="news-banner">
            {/* <img className="news-banner-img" src={banner} /> */}
            <div className="banner-title">
                <h1>新闻动态</h1>
                <h3>慧脑云在探索脑健康与脑医学产品落地、以及支撑脑科学前沿研究方面，发挥重要作用。</h3>
            </div>
        </div>
        {/* <div className="main-news">
            <img src={latestNewsImg} className="main-news-img" />
            <div className="main-news-info">
                <p className="main-news-time">2021年10月</p>
                <h2 className="main-news-title">基金委重大项目“癫痫异常脑功能活动位点和连接的多模态影像学研究”正式启动</h2>
                <div className="main-news-content">
                    慧脑云先进可靠的平台架构有效地解决了硬件资源管理和高性能计算的问题，并且慧脑云专业的服务团队全方位保障了脑影响数据分析的科学性和有效性。克服了传统模式下，研究机构在使用硬件设备进行影像处理的过程中...<Link to="/latest-news">详细</Link>
                </div>
            </div>
        </div> */}
        <div className="news-preview">
            <div>
                {
                    newDetail.map((news, index) => {
                        if (year == "all") {
                            return <div className="news-container">
                                <div className="news-desc">
                                    <p className="news-time">{news.time}</p>
                                    <h2 className="news-info" onClick={() => toNewsDetail(index)}>{news.title}</h2>
                                </div>
                            </div>
                        }
                        if (news.header[0].split("年")[0] == year) {
                            return <div className="news-container">
                                <div className="news-desc">
                                    <p className="news-time">{news.time}</p>
                                    <h2 className="news-info" onClick={() => toNewsDetail(index)}>{news.title}</h2>
                                </div>
                            </div>
                        } else {
                            return null
                        }
                    })
                }
            </div>
            <div className="time-progress">
                <div className="total" onClick={() => setYear("all")} style={{ color: year == "all" ? "#3A5295" : "#999" }}>全部</div>
                {Array.from(years).map(item => {
                    return <div className="time" onClick={() => setYear(item.split("年")[0])} style={{ color: year == item.split("年")[0] ? "#3A5295" : "#999" }}>
                        {item}
                    </div>
                })}
            </div>
        </div>
        {/* <div className="load-more">查看更多 <DownOutlined /></div> */}
    </div>
}

export default LatestNews;